import Dictionary from './Dictionary';
import './App.css';

function App() {
  return (
    <div className="App">
       <h1>
          Dictionary
        </h1>
      <div className="container">
      <header className="App-header">
      </header>
<Dictionary defaultKeyword="Yoga"/>
      </div>
      <footer> <a href="https://github.com/martuman95/dictionary-proj">Open Source Code</a> by <a href="https://www.instagram.com/martugram_/?hl=it">Marta Manunta</a></footer>
    </div>
  );
}

export default App;
